module.exports = __webpack_public_path__ + "static/media/1008123.7f805e47.png";